import datamethods from './datamethods.js'
import {mapFields} from 'vuex-map-fields'
export default{
    mixins:[datamethods],
    computed:{
        ...mapFields([
            'loggedInUser',
            'applicationMode',
            'securityAppName',
            'tutorialItems',
            'tutorialIndex',
            'tutorialMaxIndex',
            'inTutorial',
            'tutorialFirstStep',
            'tutorialLastStep',
            'showTutorial'
        ]),
        currentTutorialStep(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].id
        },
        currentTutorialStepName(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].name
        },
        currentTutorialStepDescription(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].description
        },
         currentTutorialStepUrl(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].url
        },
        currentTutorialStepElementName(){
            if(this.tutorialItems.length==0){return null}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return null}
            return this.tutorialItems[this.tutorialIndex-1].uiElementName
        },
        tutorialScreenLocation(){
            if(this.tutorialItems.length==0){return 'main'}
            if(this.tutorialIndex==0 || this.tutorialIndex>this.tutorialMaxIndex){return 'main'}
            return this.tutorialItems[this.tutorialIndex-1].screenLocation
        },
        tutorialExists(){
            return this.tutorialItems.length>0
        },

        allowLocationSelection(){
            if(this.applicationMode==null){return true}//if there isn't an app mode defined, let them pick location
            return this.applicationMode=='Full' || this.applicationMode=='full'
        },
    },
    data(){
        return{
            
        }
    },
    methods:{
        async getApplicationMode(){
            let req = {
                ID:this.loggedInUser.LocationId
            }
            //call api
            var response = await this.callAPI(req,'applicationmode')
            //handle response
            if(response.Successful){
              this.applicationMode=response.StringResponse  
              console.log('application mode ' + this.applicationMode)
              if(this.applicationMode=='Trial' && !this.inTutorial){
                    this.tutorialStart()
              }
            }else{
              this.responseMessage = response.Message
            }
           
        },

        async getTutorial(){
            let req = {
                tutorialName:this.securityAppName
            }
            //call api
            var response = await this.callAPI(req,'tutorial')
            //handle response
            if(response.Successful){
             this.tutorialItems=response.tutorialItems  
              this.inTutorial=true
              this.tutorialShow()
              this.tutorialIndex=1
              this.tutorialMaxIndex=this.tutorialItems.length
              this.tutorialFirstStep = response.firstStepIndex
              this.tutorialLastStep=response.lastStepIndex
              this.setHighlight()
            }else{
              this.responseMessage = response.Message
            }
           
        },
        tutorialHide(){
            this.showTutorial=false
        },
        tutorialShow(){
            this.showTutorial=true
            this.setHighlight()
        },
        tutorialNext(){
            if(this.tutorialIndex<=this.tutorialMaxIndex){
                this.removeHighlight()
                this.tutorialIndex=Number(this.tutorialIndex) + 1
                if(this.tutorialIndex<=this.tutorialMaxIndex){
                    this.setHighlight()
                }else{
                    this.tutorialDone() //auto done
                }
            }
        },
        tutorialPrevious(){
            if(this.tutorialIndex>1){
                this.removeHighlight()
                this.tutorialIndex=Number(this.tutorialIndex) - 1
                this.setHighlight()
            }else{
                this.tutorialBackOut() //auto done
            }
        },
        setHighlight(){
            console.log(this.currentTutorialStepElementName)
            var el =document.getElementById(this.currentTutorialStepElementName)
            if(el!=undefined){
                el.classList.add("highlightelement")
            }
        },
        removeHighlight(){
            console.log(this.currentTutorialStepElementName)
            var el =document.getElementById(this.currentTutorialStepElementName)
            if(el!=undefined){
                el.classList.remove("highlightelement")
            }
            
        },
        tutorialStart(){
            this.getTutorial()
        },
        tutorialEnd(){
            this.removeHighlight()
            this.inTutorial=false
        },


        //tutorial done: the admin home/parent version
        /* tutorialDone(){
           //tell parent to show message!
            this.$emit('tutorialmessage')

            this.tutorialEnd()

            //tell the kids
            this.sendMessage_AllChildApps('tutorialend')
        }, */

        //tutuorial done: the child version
        tutorialDone(){
            console.log('tutorial done child')
            this.tutorialEnd()
            
            //tell the parent app
            const message = JSON.stringify({
                to:'AdminHome',
                id:0,
                action:'tutorialdone_child'
            })
            window.parent.postMessage(message, '*')
        },
         tutorialBackOut(){
            console.log('tutorial back out child')
            this.tutorialEnd()
            
            //tell the parent app
            const message = JSON.stringify({
                to:'AdminHome',
                id:0,
                action:'tutorialback_child'
            })
            window.parent.postMessage(message, '*')
        }
        
    }

}